import { darken, ThemeOptions } from "@mui/material/styles";

import { getInvertColor } from "utils/themeUtils";

export const formControlOverrides: ThemeOptions["components"] = {
	MuiFormControl: {
		styleOverrides: {
			root: ({ ownerState: { color }, theme }) => {
				const mainColor = theme.palette[`${color}`]?.main || theme.palette.primary.main;
				const isLight = getInvertColor(mainColor) === theme.palette.dirtyWhite["2000"];
				const isPrimaryOrSecondary = ["primary", "secondary"].includes(`${color}`);

				return {
					"& .MuiInputLabel-shrink:not(.Mui-disabled)": {
						color: isPrimaryOrSecondary && isLight ? darken(mainColor, 0.5) : mainColor,
					},
				};
			},
		},
	},
};
